import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./index.scss";
import { Modal, Offcanvas } from "react-bootstrap";
import backicon from "../../../../../Assets/icons/backIcon.svg";
import axiosInstance from "../../../../services/api/API";
import moment from "moment";
import viewIcon from '../../../../../Assets/icons/eye 1.svg';
import "bootstrap/dist/css/bootstrap.min.css";
import AddIssueDynemicForm from "../../../Services/addIssueDynemicFrom";
import ReactSignatureCanvas from "react-signature-canvas";

const ReceiptDetails = () => {
  const location = useLocation();
  const { data } = location?.state || {};
  const navigate = useNavigate();
  const [jobCardDetails, setJobCardDetails] = useState([]);
  const [personalDetails, setPersonalDetails] = useState(null);
  const [modalType, setModalType] = useState(null);
  const token = localStorage.getItem("authToken");
  const [formData, setFormData] = useState({ issue_status: 0 });
  const [complainList, setComplainList] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const [signatureModel, setSignatureModel] = useState(false);
  const [UpdateModel, setUpdateModel] = useState(false);
  const [editIssueData, setEditIssueData] = useState();
  const [paybleTotalAmount, setPaybleTotalAmount] = useState(null);
  const [transactionDetails, setTransactionDetails] = useState([]); 
  const [totalTransaction_Amount,setTotalTransaction_Amount] =useState(null);// Add state for remark

  const [issueId, setIssueId] = useState(0);
  const [addModel, setAddModel] = useState(false);
  const bussness_id = data?.business_partner_id;
  const job_Card_id = data?.job_card_id;
  const po_id = data?.po_id;
  const po_details_id = data?.po_details_id;
  console.log("formData?????",formData?.Payment_mode);

  const businessPartnerId = localStorage.getItem("business_partner_id")
  console.log(businessPartnerId, "businesspartnerid")
  

  const sigCanvas = useRef();
  const IssueInputs = [
    {
      name: "Payment_mode",
      label: "Payment Mode",
      type: "dropdown",
      placeholder: "Enter Complain Description",
      required: true,
      options: [
        {
          label: "Online",
          value: 3,
        },
        {
          label: "Cash",
          value: 1,
        },
      ],
      gridClass: "col-lg-12 mb-3",
      validation: {
        required: true,
        // pattern: /^[A-Za-z0-9 ]*$/,
        // message: "Only alphabets and digits are allowed",
      },
      disabled: true,
    },
    {
      name: "transaction_Amount",
      label: "Transaction Amount",
      type: "text",
      placeholder: "Enter Complain Description",
      required: true,
      gridClass: "col-lg-12 mb-3",
      validation: {
        required: true,
        // pattern: /^[A-Za-z0-9 ]*$/,
        // message: "Only alphabets and digits are allowed",
      },
    },
    {
      name: "Transaction_No",
      label: "Transaction No.",
      type: "text",
      placeholder: "Enter Complain Description",
      required: true,
      gridClass: "col-lg-12 mb-3",
      validation: {
        required: true,
      },
    },

    {
      name: "transaction_date",
      label: "Transaction Date",
      type: "date",
      placeholder: "Transaction Date",
      required: true,
      gridClass: "col-lg-12 mb-3",
      validation: { required: true },
    },
    ...(formData?.Payment_mode === 3
      ? [
          {
            name: "receipt_data",
            label: "Receipt",
            type: "agentfile",
            required: true,
            gridClass: "col-lg-12 mb-3",
      validation: { required: true },
           
          },
        ]
      : []),
    // {
    //   name: "receipt_data",
    //   label: "Receipt",
    //   type: "agentfile",
    //   placeholder: "Enter Estimate Cost",
    //   required: true,
    //   gridClass: "col-lg-12 mb-3",
    //   validation: { required: true },
    // },
  ];

  const onClickSetIssueId = (id) => {
    if (id == "") {
      setIssueId("");
    } else {
      setIssueId(id);
    }
  };

  const fetchJobCardIssueList = async (page = 0, pageSize = 1) => {
    try {
      const response = await axiosInstance.post(
        "/receiptpayment/list",
        {
          business_partner_id: data?.business_partner_id || businessPartnerId,
          po_id: po_id,
          po_details_id:po_details_id
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const formattedData = response?.data?.data?.datares || [];
      setTotalTransaction_Amount(response?.data?.data);
      setTransactionDetails(formattedData);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const fetchJobCardDetails = async (page = 0, pageSize = 1) => {
    if (job_Card_id !== null) {
      try {
        const response = await axiosInstance.post(
          "/popaymentreciptinvoice/details",
          {
            po_id:po_id,
            po_details_id:po_details_id
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log("assasas1212121", response);
        const formattedData = response?.data?.data || {};
        setPersonalDetails(formattedData);
        console.log("personalDetails",personalDetails);
        
        // setJobCardIssueList(formattedData);
      } catch (error) {
        console.error("Error fetching business partners:", error);
      }
    }
  };
  console.log("Formdatapayment",formData);
  

  const fetchComplainList = async (page = 0, pageSize = 1) => {
    try {
      const response = await axiosInstance.post(
        "/jobcardinvoicepayment/getInvoiceItemComplainView",
        {
          business_partner_id: data?.business_partner_id || businessPartnerId,
          job_card_id: job_Card_id || null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const formattedData = response?.data?.data?.data || [];
      setPaybleTotalAmount(response?.data?.data);
      setComplainList(formattedData);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const handleFormSubmit = async (data) => {
    console.log("paymentdata",data);

    if(data?.Payment_mode===1){
     
    const  payload={
        onboard_bp_id:1,
        po_id:po_id,
        po_details_id:po_details_id,
        bill_no:data?.Transaction_No,
        amount:data?.transaction_Amount,
        mode_date:data?.transaction_date,
        payment_mode_id:data?.Payment_mode
      }
      // formData.append("onboard_bp_id", 1);
      // formData.append("po_id", po_id);
      // formData.append("po_details_id", po_details_id);
      // formData.append("bill_no", data?.Transaction_No);
      // formData?.append("amount", data?.transaction_Amount);
      // formData?.append(
      //   "mode_date",
      //   moment(data?.transaction_date).format("YYYY-MM-DD")
      // );
      // formData?.append("payment_mode_id", data?.Payment_mode);
      console.log("payload",payload);
      
      try {
        const response = await axiosInstance.post(
          "/receiptpayment/createOfflinePayment",
          payload,
          {
            headers: {
            
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response?.status) {
          setAddModel(false);
          setUpdateModel(false)
        fetchJobCardIssueList()
        setFormData({})
          // fetchJobCardIssueList();
          // fetchJobCardDetails();
          // setFormData({ issue_status: 0 });
          // const AddIssueData = response?.data?.data?.responseData;
          // navigate("/manage-services/job-card/job-card-details", {
          //   state: { data: JSON.parse(JSON.stringify(AddIssueData)) },
          // });
        
        }
      } catch (error) {
        console.error("Error fetching business partners:", error);
      }
    }
    else{

    
    
    const formData = new FormData();
    formData.append("onboard_bp_id", 1);
    formData.append("po_id", po_id);
    formData.append("po_details_id", po_details_id);
    formData.append("bill_no", data?.Transaction_No);
    formData?.append("amount", data?.transaction_Amount);
    formData?.append(
      "mode_date",
      moment(data?.transaction_date).format("YYYY-MM-DD")
    );
    formData?.append("receiptFile", data?.receipt_data);
    formData?.append("payment_mode_id", data?.Payment_mode);
    
    try {
      const response = await axiosInstance.post(
        "/receiptpayment/createOnlinePayment",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.status===200) {
        setAddModel(false);
        setUpdateModel(false)
        fetchJobCardIssueList()
        setFormData({})
    
      }
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };
  }


  const handleClose = () => {
    setUpdateModel(false);
  };

  useEffect(() => {
    if (data) {
      fetchJobCardIssueList();
      fetchJobCardDetails();
      fetchComplainList();
    }
  }, [data]);
console.log("transactionDetails",totalTransaction_Amount?.pendingAmount);


  const openImageInNewTab = (transactionDetails) => {
    window.open(`${transactionDetails?.receipt_path}`,);
  };
  
  return (
    <div className="container-fuiled">
      <div className="OnboardManagamentContainer  mt-2 mb-2">
        <span className="backbtntitle" onClick={()=>navigate(-1)}>
          {" "}
          <img src={backicon} alt="back" style={{ marginRight: 5 }} /> Payment
          Invoice Details
        </span>
        {personalDetails?.poDetailsData[0].fullamountrecived ===0 && 
        <div className="gap-5">
        <button
          className="addcustomerbutton "
          onClick={() => setUpdateModel(true)}
        >
          Update  
        </button>
      </div>  
        }
        
      
      </div>
      <div className="container-fuiled row   ">
        <div className="col-md-6 vechalDetails">
          <div>
            <h5 className="m-3">Purchase Order Details</h5>
            <div className="mt-3 m-3">
              <div className="invoice-vechal-Details-SubView">
                <div className="details-item">
                  <span className="details-label">Reference No.</span>
                  <span className="details-value">
                    {personalDetails?.poData[0]?.reference_no || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Vendor Name</span>
                  <span className="details-value">
                    {personalDetails?.poData[0]?.companyname || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Order No.</span>
                  <span className="details-value">
                    {personalDetails?.poData[0]?.po_number || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">PO Date</span>
                  <span className="details-value">
                    {personalDetails?.poData[0]?.po_date || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Payment Term</span>
                  <span className="details-value">
                    {personalDetails?.poData[0]?.payment_term_name || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Payment Mode</span>
                  <span className="details-value">
                    {personalDetails?.poData[0]?.payment_mode || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Payment Date</span>
                  <span className="details-value">
                    {personalDetails?.poData[0]?.payment_date || "-"}
                  </span>
                </div>
              </div>
            </div>
            <br />
            <div className="borderWidth">
              <h5 className="m-3">Product Details</h5>
            </div>
            <div className="mt-3 m-3">
              <div className="invoice-vechal-Details-SubView">
                <div className="details-item">
                  <span className="details-label">Product</span>
                  <span className="details-value">
                    {personalDetails?.poDetailsData[0]?.product_name || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Sub Product</span>
                  <span className="details-value">
                  {personalDetails?.poDetailsData[0]?.subproduct_name || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Make</span>
                  <span className="details-value">
                  {personalDetails?.poDetailsData[0]?.make_name || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Model</span>
                  <span className="details-value">
                  {personalDetails?.poDetailsData[0]?.model_name || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Variant</span>
                  <span className="details-value">
                  {personalDetails?.poDetailsData[0]?.variant_name || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Item</span>
                  <span className="details-value">
                  {personalDetails?.poDetailsData[0]?.item_name || "-"}
                  </span>
                </div>
                {/* <div className="details-item">
                  <span className="details-label">Fuel Type</span>
                  <span className="details-value">
                    {personalDetails?.fuel_type_name || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Chassis No.</span>
                  <span className="details-value">
                    {personalDetails?.chassis_no || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Engine No.</span>
                  <span className="details-value">
                    {personalDetails?.engineno || "-"}
                  </span>
                </div>

                <div className="details-item">
                  <span className="details-label">Registration No.</span>
                  <span className="details-value">
                    {personalDetails?.registration_no || "-"}
                  </span>
                </div> */}
              </div>
            </div>
            <br />
            <div className="borderWidth">
              <h5 className="m-3">Item Details</h5>
            </div>
            <div className="mt-3 m-3">
              {/* <div className="invoice-vechal-Details-SubView"> */}
              <table className="payment-invoice-table">
                <thead>
                  <tr>
                    <th>Part Name</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <th>Total Cost</th>
                  </tr>
                </thead>
                <tbody>
                  
                    <tr >
                      <td className="text">
                      {personalDetails?.poDetailsData[0]?.item_name || "-"}
                      </td>
                      <td className="text">
                      {personalDetails?.poDetailsData[0]?.quantity || "-"}
                      </td>
                      <td className="text">
                      {personalDetails?.poDetailsData[0]?.rate || "-"}
                      </td>
                      <td className="text">
                         {personalDetails?.poDetailsData[0]?.costamount || "-"}
                      </td>
                    </tr>
                
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan={3}>Total</td>
                    <td> {personalDetails?.poDetailsData[0]?.costamount || "-"}</td>
                  </tr>
                  <tr>
                    <td colSpan={3}>Tax ({(personalDetails?.poDetailsData[0]?.tax)})</td>
                    <td> {(personalDetails?.poDetailsData[0]?.taxset_amount)}</td>
                  </tr>
                  <tr>
                    <td colSpan={3}>Total Payable Amount</td>
                    <td> {(personalDetails?.poDetailsData[0]?.totalprice)}</td>
                  </tr>
                </tfoot>
              </table>
              {/* <footer className="invoice-footer">
          <div className="pminfo"></div>
          <div className="total">
            <div className="totalval">
              
              <span>Subtotal:</span>
              <span>&#8377;{'5000' ||'-'}</span>
            </div>
            <div className="totalval">
              <span>Tax ({'18'}):</span> <span>&#8377;{Number('4000').toFixed(2) || '0'}</span>
            </div>
            <div className="grandtotal">
              <span>Grand Total: </span>
              <span>&#8377;{ Number('5000').toFixed(2) || '0'}</span>
            </div>
          </div>
        </footer> */}
              {/* </div> */}
            </div>
          </div>
        </div>
        <div className="col-6">
          <div className="addButtonStyle m-3">
            <h5>Payment History</h5>
          </div>
          <div className="issue-list-parent-container">
            <table className="payment-invoice-table">
              <thead>
                <tr>
                  <th>Payment Mode</th>
                  <th>Tran. No.</th>
                  <th>Tran. Date</th>
                  <th>Upload Image</th>
                  <th>Tran. Amount</th>
                </tr>
              </thead>
              <tbody>
                {(transactionDetails || []).map((transactionDetails, index) => (
                  <tr>
                    <td className="text">
                      {transactionDetails?.payment_mode || "-"}
                    </td>
                    <td className="text">
                      {transactionDetails?.bill_no || "-"}
                    </td>
                    <td className="text">
                      {transactionDetails?.mode_date}
                    </td>
                    <td className="text">
                    <div >
                      {/* <img src={viewIcon}/>  */}
                      </div>
                      {transactionDetails?.payment_mode ==="Online" &&<img src={`${transactionDetails?.receipt_path}`}  style={{width:20,height:20,alignItems:'center'}}
                        onClick={()=>openImageInNewTab(transactionDetails)}
                       />  }
                       
                      
                     
                    </td>
                    <td className="text">
                     {transactionDetails?.amount || "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td className="textleft"> Total Amt.</td>
                  <td className="textleft">{totalTransaction_Amount?.totalAmount || '-'}</td>
                  <td className="textleft">Pending Amt.</td>
                    <td className="textleft"> {totalTransaction_Amount?.pendingAmount  || 0}</td>
                    <td className="textleft"> {totalTransaction_Amount?.totalTranAmount || 0}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <Offcanvas placement={"end"} show={UpdateModel} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {"Add Payment Details"}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="col-lg-12">
            <AddIssueDynemicForm
              formConfig={IssueInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />

            <div className="col-12 ">
              <button
                onClick={() => {
                  handleFormSubmit(formData);
                }}
                className="submit-btn w-100"
              >
                {"Submit"}
              </button>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default ReceiptDetails;
